var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.995 4H6.995C3.165 4 2.095 4.92 2.005 8.5C3.935 8.5 5.495 10.07 5.495 12C5.495 13.93 3.935 15.49 2.005 15.5C2.095 19.08 3.165 20 6.995 20H16.995C20.995 20 21.995 19 21.995 15V9C21.995 5 20.995 4 16.995 4Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99329 4V7.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99329 16.5V20",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.025 9.33003L15.645 10.58C15.705 10.7 15.825 10.79 15.955 10.81L17.335 11.01C17.675 11.06 17.815 11.48 17.565 11.72L16.565 12.69C16.465 12.78 16.425 12.92 16.445 13.06L16.685 14.43C16.745 14.77 16.385 15.03 16.085 14.87L14.855 14.22C14.735 14.16 14.585 14.16 14.465 14.22L13.235 14.87C12.925 15.03 12.575 14.77 12.635 14.43L12.875 13.06C12.895 12.92 12.855 12.79 12.755 12.69L11.765 11.72C11.515 11.48 11.655 11.06 11.995 11.01L13.375 10.81C13.515 10.79 13.625 10.71 13.685 10.58L14.295 9.33003C14.435 9.02003 14.875 9.02003 15.025 9.33003Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketStar);
export default __webpack_public_path__ + "static/media/ticket-star.be70c2fd5e9f1981c3597d48de515b82.svg";
export { ForwardRef as ReactComponent };